var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parent pa-3"},[_c('div',{staticClass:"pa-2"},[_c('v-icon',{attrs:{"color":"yellow"}},[_vm._v("mdi-alert")])],1),_vm._v(" "),_c('div',{staticClass:"pl-2"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }